export const formatPrice = (
  price?: number,
  options?: {
    prefix?: string | null;
    suffix?: string | null;
  },
) => {
  const { prefix = null, suffix = '₺' } = options || {};
  if (price === undefined || price === null || isNaN(price)) price = 0;

  const priceStr =
    price?.toLocaleString('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) ||
    price?.toFixed(2) ||
    '-';

  return [prefix, priceStr, suffix].filter(Boolean).join('');
};
